import start from '../../../../assets/schulung/start.webp'
import unterstuetzer from '../../../../assets/schulung/unterstuetzer.webp'
import hilfeknopf from '../../../../assets/schulung/hilfeknopf.webp'
import anforderungen from '../../../../assets/schulung/anforderungen.webp'
import skills4retail from '../../../../assets/schulung/skills4retail.webp'
import aktivierung from '../../../../assets/schulung/aktivierung.webp'
import lulupload from '../../../../assets/schulung/lulupload.webp'
import hygiene from '../../../../assets/schulung/hygiene.webp'
import einstellungen from '../../../../assets/schulung/einstellungen.webp'
import handbuchBild from '../../../../assets/schulung/handbuch.webp'
import fuehrerschein from '../../../../assets/schulung/fuehrerschein.webp'

/*
 * Die Inhalte der Schulung „Neu im Schuljahr 2026/27".
 *
 * Wie das Handbuch bewusst **im Code** und nicht in der Datenbank: Die Schulung
 * beschreibt, wie die Anwendung funktioniert, und gehört damit zur Anwendung.
 * Eine Datenbankpflege würde beides entkoppeln — bei der nächsten Änderung
 * stünde in der Schulung dann etwas Falsches, und niemand merkte es.
 *
 * FÜR WEN DAS GESCHRIEBEN IST
 * ---------------------------
 * Für die Landes- und Bundesadministration. Das sind **keine** IT-Leute, und
 * die meisten arbeiten nicht täglich mit der Anwendung. Daraus folgen drei
 * Regeln, die beim Ergänzen einer Folie einzuhalten sind:
 *
 *   1. **Jede Folie beantwortet drei Fragen:** Was ändert sich? Was heißt das
 *      für mich? Und worauf muss ich aufpassen? Genau in dieser Reihenfolge
 *      stehen `goal`, `facts`, `rules` und `watch` auf der Folie.
 *   2. **Keine Fachsprache und keine Bilder aus der Technik.** Kein „Code",
 *      kein „Kanal", kein „Nummernkreis", kein „fest verdrahtet". Wer einen
 *      Satz nur versteht, weil er weiß, wie die Anwendung gebaut ist, hat den
 *      Satz für dieses Publikum nicht geschrieben.
 *   3. **Wörter aus der Oberfläche, nicht eigene.** Was in der Anwendung
 *      „Elternbestätigung prüfen" heißt, heißt hier nicht „freigeben" — sonst
 *      sucht jemand nach einem Knopf, den es nicht gibt. Im Zweifel in
 *      `shared/i18n/ger.js` nachsehen, bevor ein Begriff erfunden wird.
 *
 * WIE EINE FOLIE AUFGEBAUT IST
 * ----------------------------
 * Jede Themenfolie beantwortet dieselben Fragen an derselben Stelle, damit man
 * beim Durchblättern nicht suchen muss:
 *
 *   audience  Für wen ist das? (Kasten rechts oben, immer an derselben Stelle)
 *   goal      Was ändert sich? Ein bis zwei Sätze.
 *   facts     Was neu ist. Kurze Zeilen.
 *   rules     Was das für euch heißt — die Handlung, nicht die Mechanik.
 *   watch     Der Satz, der einem Ärger erspart. Optional.
 *
 * Die Überschriften der beiden Spalten stehen in `Slide.jsx`; eine Folie, die
 * andere braucht, setzt `factsTitle` und `rulesTitle`.
 *
 * WO EIN BILD MEHR SAGT ALS EINE AUFZÄHLUNG
 * -----------------------------------------
 * Drei Folien zeigen statt zu beschreiben. Sie sind kein Schmuck: Jede ersetzt
 * eine Aufzählung, die dasselbe nur behauptet hätte.
 *
 *   checklist  Die Checkliste, wie die Schüler:innen sie sehen — statt ihre
 *              Punkte aufzuzählen (steht anstelle der `rules`-Spalte).
 *   linkOut    Ein Verweis nach außen, anklickbar statt abgetippt.
 *   timeline   Phasen untereinander (derzeit von keiner Folie genutzt).
 *
 * `linkOut` und `timeline` stehen in der Seitenspalte und schließen ein `image`
 * damit aus — dort ist Platz für eines von beiden.
 *
 * PRIORITÄT UND REIHENFOLGE
 * -------------------------
 * `priority` trägt drei Werte von 1 bis 3: Relevanz (betrifft es viele?),
 * Dringlichkeit (muss man es zum Schuljahresstart wissen?) und Wichtigkeit
 * (was passiert, wenn man es nicht weiß?). Die Folien stehen in der Reihenfolge
 * dieser Summe — nicht in der Reihenfolge der Auslieferung. Wer die Schulung
 * abbricht, hat dann wenigstens das Wichtigste gesehen.
 *
 * **Weniger ist hier die Vorgabe.** Der Umfang ist am 31.08.2026 von 19 Folien
 * und 9 Fragen auf 16 und 6 gekürzt worden: Vier Folien beschrieben dieselbe
 * Sache aus zwei Blickwinkeln (Hilfe-Knopf und Anforderungsliste, die beiden
 * Nachweise), und eine Schulung, die nach zwanzig Minuten noch läuft, wird
 * abgebrochen. Wer etwas ergänzt, prüft zuerst, was dafür weg kann.
 *
 * WIE MAN PRÜFT, OB EINE FOLIE PASST
 * ----------------------------------
 * Eine Folie hat feste Höhe (16:9). Zu viel Text schiebt sich unter den
 * „Aufpassen"-Kasten; das Layout schneidet seit 26.08.2026 ab statt zu
 * überlappen, aber abgeschnittener Text ist auch keine Lösung. **Aus der
 * Zeichenzahl lässt sich das nicht verlässlich schätzen** — versucht und
 * verworfen, die umgebrochene Höhe hängt zu sehr an der Länge der einzelnen
 * Punkte.
 *
 * Gemessen wird am fertigen Bild. Dieses Schnipsel in der Browserkonsole
 * blättert durch alle Folien und meldet, welche überlaufen:
 *
 *   (async () => {
 *     const w = ms => new Promise(r => setTimeout(r, ms))
 *     const p = () => [...document.querySelectorAll('[aria-label^="Folie"]')]
 *     const raus = []
 *     for (let i = 0; i < p().length; i++) {
 *       p()[i].click(); await w(110)
 *       const li = [...document.querySelectorAll('section ul li')]
 *       if (!li.length) continue
 *       const unten = Math.max(...li.map(l => l.getBoundingClientRect().bottom))
 *       const kasten = [...document.querySelectorAll('p')]
 *         .find(x => /AUFPASSEN/i.test(x.textContent))
 *       const folie = document.querySelector('[class*="slide"]').getBoundingClientRect()
 *       const grenze = kasten ? kasten.getBoundingClientRect().top : folie.bottom - 12
 *       if (unten > grenze) raus.push(i + ': +' + Math.round(unten - grenze) + 'px')
 *     }
 *     return raus.join(' | ') || 'alle passen'
 *   })()
 *
 * AUDIENCE
 * --------
 * `INTERN` heißt: Das sieht nur die Verwaltung. Das ist die Angabe, nach der am
 * häufigsten gefragt wird — „muss ich das den Schulen erklären?"
 */

export const AUDIENCES = {
	INTERN: { key: 'INTERN', label: 'Verwaltung', short: 'Verw.' },
	TEACHER: { key: 'TEACHER', label: 'Lehrkräfte', short: 'LuL' },
	STUDENT: { key: 'STUDENT', label: 'Schüler:innen', short: 'SuS' },
	SUPPORTER: { key: 'SUPPORTER', label: 'Unterstützer:innen', short: 'Unter.' }
}

/** Die feste Reihenfolge der Symbole. Sie steht auf jeder Folie gleich. */
export const AUDIENCE_ORDER = ['INTERN', 'TEACHER', 'STUDENT', 'SUPPORTER']

export const PRIORITY_LABELS = {
	relevance: 'Relevanz',
	urgency: 'Dringlichkeit',
	importance: 'Wichtigkeit'
}

/*
 * Die Fragen.
 *
 * Sie hängen an der Folie davor und sind bewusst wenige: Die Schulung soll in
 * einer Kaffeepause durchzukommen sein. Eine Frage prüft **eine** Sache, und
 * zwar die, deren Verwechslung im Alltag wehtut — nicht eine Jahreszahl.
 *
 * `hint` ist der Joker „Tipp": ein Satz, der zur Antwort führt, ohne sie zu
 * nennen. `why` steht nach dem Antworten da — auch bei richtiger Antwort, denn
 * geraten wird auch richtig.
 */

const F = (key, question, options, correct, hint, why) => ({ key, question, options, correct, hint, why })

export const SLIDES = [
	{
		id: 'start',
		kind: 'intro',
		kicker: 'Onboarding 2026/27',
		title: 'Bereit für ein neues Junior-Jahr',
		lead: 'Im vergangenen Schuljahr sind über sechshundert Junior Companies durch das Programm gegangen. Über den Sommer ist die Junior Datenbank kräftig gewachsen. Auf den nächsten Folien steht, was neu ist, was das für eure Arbeit bedeutet und worauf ihr achten solltet — kurz gehalten und ohne Fachsprache.',
		image: start,
		bullets: [
			'Etwa 10 Minuten. Blättern mit den Pfeiltasten oder den Knöpfen unten.',
			'Sechsmal kommt eine kurze Frage — mit beliebig vielen Anläufen.',
			'Drei Joker stehen bereit, falls eine Frage kniffliger ist.'
		]
	},

	/*
	 * Die wichtigste Folie der Schulung und deshalb die erste: Was hier
	 * schiefgeht, hält eine ganze Klasse auf — und zwar ohne dass jemand eine
	 * Fehlermeldung sieht.
	 *
	 * Sie fasst zusammen, was bis 31.08.2026 auf zwei Folien stand (Gen-AI-
	 * Urkunde und die Freigabe der Elternbestätigung). Beide beschreiben
	 * dieselbe Handlung an derselben Stelle, und der Unterschied zwischen ihnen
	 * ist genau der Punkt, den man kennen muss.
	 */
	{
		id: 'nachweise',
		kind: 'topic',
		title: 'Zwei Unterlagen je Schüler:in — und was ihr damit tut',
		kicker: 'Eure wichtigste Handlung im Alltag',
		audience: ['INTERN', 'TEACHER', 'STUDENT'],
		priority: { relevance: 3, urgency: 3, importance: 3 },
		goal: 'Jede Schüler:in legt zwei Unterlagen in ihrem Profil ab: die Einverständniserklärung der Eltern und — neu ab heuer — die Urkunde eines Kurses zu künstlicher Intelligenz. Hochgeladen werden beide von den Schüler:innen. Was danach zu tun ist, ist bei den beiden verschieden.',
		facts: [
			'**Neu:** Jede Schüler:in braucht die Urkunde eines Gen-AI-Kurses. Welcher Kurs gilt, steht mit Link in den Einstellungen.',
			'Hochgeladen wird im eigenen Profil unter „Nachweise".',
			'Ihr seht beide Unterlagen im Profil der Schüler:in, in der Liste „Dokumente" und bei der Firmenprüfung.'
		],
		/*
		 * Der Link steht als Verweis da und nicht als abgetippte Adresse: Auf
		 * die Frage „welcher Kurs denn?" ist ein anklickbarer Kurs die Antwort,
		 * eine 120 Zeichen lange Adresse zum Abschreiben nicht.
		 */
		linkOut: {
			label: 'Der hinterlegte Kurs',
			source: 'LinkedIn Learning',
			title: 'What is Generative AI?',
			url: 'https://www.linkedin.com/learning/what-is-generative-ai/how-generative-ai-is-different-than-other-types-of-ai',
			short: 'linkedin.com/learning/what-is-generative-ai',
			note: 'Einstellungen → Voraussetzungen für Aktivierung'
		},
		rulesTitle: 'Was das für euch heißt',
		rules: [
			'**Elternbestätigung:** Sie zählt erst, wenn **ihr** sie geprüft habt. Tut ihr nichts, kommt die Junior Company nicht weiter.',
			'**Gen-AI-Urkunde:** Sie zählt schon, sobald sie da ist. Tut ihr nichts, gilt sie.',
			'Geprüft wird in der Liste „Benutzer:innen": im Menü der Zeile „Elternbestätigung (muss überprüft werden)".',
			'Stimmt etwas nicht, beanstandet ihr die Unterlage mit einer Begründung. Die Schüler:in bekommt eine Nachricht und lädt neu hoch.'
		],
		watch: 'Die beiden Regeln laufen gegeneinander: Bei der Elternbestätigung heißt Nichtstun „nein", bei der Gen-AI-Urkunde „ja". Eine Urkunde, die nichts taugt — etwa ein Bildschirmfoto ohne Namen —, müsst ihr also ausdrücklich beanstanden. Liegen lassen genügt hier nicht.'
	},
	F(
		'q-nachweise',
		'Eine Schüler:in lädt ihre Gen-AI-Urkunde hoch. Ihr seht sie euch an: ein Bildschirmfoto ohne Namen, unbrauchbar. Was müsst ihr tun?',
		[
			'Nichts — ungeprüft zählt sie ohnehin nicht',
			'Sie ausdrücklich beanstanden, sonst gilt die Voraussetzung als erfüllt',
			'Die Junior Company ablehnen',
			'Die Lehrkraft bitten, sie zu löschen'
		],
		1,
		'Anders als die Elternbestätigung braucht diese Urkunde keine Prüfung durch euch. Überlegt, was das für den umgekehrten Fall bedeutet.',
		'Die Gen-AI-Urkunde gilt, sobald sie da ist, und wird erst durch eine Beanstandung wieder offen. Liegen lassen genügt hier also nicht — anders als bei der Elternbestätigung, wo ohne eure Prüfung nichts weitergeht.'
	),

	{
		id: 'aktivierung',
		kind: 'topic',
		title: 'Die Liste, die vor dem Start erfüllt sein muss',
		kicker: 'Alle sehen dasselbe',
		image: aktivierung,
		audience: ['INTERN', 'TEACHER', 'STUDENT'],
		priority: { relevance: 3, urgency: 3, importance: 3 },
		goal: 'Bevor eine Junior Company loslegen darf, muss sie eine Reihe von Punkten erfüllen. Neu ist: Diese Liste steht nicht mehr ein für alle Mal fest, sie lässt sich ändern. Und Schüler:innen, Lehrkraft und Verwaltung sehen dieselben Punkte und denselben Stand.',
		facts: [
			'Welche Punkte gelten, steht in den Einstellungen. Jeder einzelne lässt sich ein- und ausschalten.',
			'Jede Zeile führt mit einem Klick dorthin, wo der Punkt zu erfüllen ist.',
			'Punkte, die nur manche betreffen — Lebensmittelhygiene, Skills4Retail —, stehen auch nur bei diesen Companies.',
			'Gezählt werden Punkte, keine Prozente: „3 von 5".'
		],
		/*
		 * Statt die Schritte aufzuzählen die Liste zeigen, die alle drei Rollen
		 * ohnehin vor sich haben. Sie erklärt in einem Bild, was vier Zeilen
		 * Text nur behaupten: dieselben Punkte, derselbe Stand, ein Weg je Zeile.
		 *
		 * Die Zeilen tragen **den Wortlaut aus der Anwendung**. Bis 31.08.2026
		 * stand dort „Einverständniserklärungen freigegeben" — verständlicher
		 * gemeint, aber es gibt weder diesen Satz noch das Wort „freigeben" in
		 * der Oberfläche, und für die Schüler:innen las es sich, als müssten
		 * *sie* etwas freigeben. Beim Nachsehen stellte sich heraus, dass die
		 * Anwendung selbst danebenlag: Die Zeile versprach „hochgeladen",
		 * gezählt wurde die Prüfung. Sie heißt seither „hochgeladen und
		 * geprüft" (`shared/activationRequirements.js`) — hier steht dieser
		 * Wortlaut. **Wer die Zeile dort ändert, ändert sie auch hier.**
		 */
		checklist: {
			title: 'Bereit zum Einreichen',
			done: 3,
			total: 5,
			items: [
				{ text: 'Unternehmensprofil & Risikoanalyse ausgefüllt', done: true },
				{ text: 'Mindestens 2 Schüler:innen als Mitarbeiter:innen', done: true },
				{ text: 'Mindestens 1 Wirtschaftsexpert:in zugewiesen', done: true },
				{ text: 'Einverständniserklärung der Eltern hochgeladen **und geprüft**', done: false, mark: true },
				{ text: 'Urkunde Gen AI Kurs hochgeladen', done: false }
			],
			note: 'Geprüft wird von euch — bis dahin bleibt der Punkt offen, auch wenn die Datei längst da ist. Abgeschaltete Punkte stehen hier gar nicht mehr.'
		},
		watch: 'Hochladen ist Sache der Schüler:innen, prüfen ist eure Aufgabe. Auf eurer Startseite steht dafür bei „Schüler:innen" die Zahl „Ausstehend": Sie zählt genau die Erklärungen, die hochgeladen sind und auf euch warten. Ein Klick darauf führt in die Liste dieser Schüler:innen.'
	},
	F(
		'q-aktivierung',
		'Eine Junior Company kann nicht einreichen, obwohl alle Einverständniserklärungen hochgeladen sind. Woran liegt es meistens?',
		[
			'Die Schüler:innen haben ein falsches Dateiformat gewählt',
			'Die Lehrkraft muss sie zuerst gegenzeichnen',
			'Die Erklärungen sind noch nicht geprüft — das ist ein eigener Arbeitsschritt der Verwaltung',
			'Die Bestätigung zur Lebensmittelhygiene fehlt'
		],
		2,
		'Hochgeladen ist nicht dasselbe wie erledigt. Wer fehlt noch?',
		'Geprüft wird laufend und unabhängig von der Firmenprüfung: Sobald eine Erklärung hochgeladen ist, wartet sie auf eurer Startseite unter „Ausstehend". Erst wenn alle geprüft sind, kann die Junior Company einreichen — regelmäßig hineinzuschauen hält den Klassen also den Weg frei.'
	),

	{
		id: 'hilfe',
		kind: 'topic',
		title: 'Der Hilfe-Knopf: Fragen kommen jetzt direkt bei euch an',
		kicker: 'Neu für Schulen und Unterstützer:innen',
		image: hilfeknopf,
		audience: ['INTERN', 'TEACHER', 'STUDENT', 'SUPPORTER'],
		priority: { relevance: 3, urgency: 3, importance: 3 },
		goal: 'Schüler:innen, Lehrkräfte und Unterstützer:innen können ihre Frage ab heuer direkt aus der Anwendung stellen — dort, wo sie gerade arbeiten. Die Frage geht an das Bundesland der Schule und landet bei euch in der Liste „Anforderungen & Anfragen".',
		facts: [
			'Runder Knopf „Hilfe" unten rechts, in jeder Ansicht nach dem Anmelden.',
			'Kurzes Formular: Art, Titel, Beschreibung, bis zu fünf Anhänge.',
			'Wo die Person gerade war, welche Rolle und welche Junior Company sie hat, geht automatisch mit.',
			'Die Person verfolgt ihren Fall unter „Meine Anfragen" und kann dort nachhaken.'
		],
		rules: [
			'Eine Anfrage gehört dem **Bundesland**, nicht einer Person: Alle Landesadmins sehen sie. Wer sie übernimmt, weist sie sich zu.',
			'Eure eigenen Anfragen gehen an die Bundesebene.',
			'Was ihr in den Fall schreibt, bleibt zunächst intern. Hinaus geht nur, was ihr als „Antworten" oder „Rückfrage" abschickt.',
			'Selbst erfasste Anforderungen und gemeldete Anfragen stehen in derselben Liste — mit einer Nummer, die bleibt und sich in einer E-Mail zitieren lässt.'
		],
		watch: 'Bei einer Antwort steht „Junior Achievement" als Absender, kein Personenname. Alles, was ihr intern vermerkt, bleibt intern — auch die Bilder darin.'
	},
	F(
		'q-hilfe',
		'Ihr schreibt in einer Anfrage einen Kommentar. Was sieht die Schülerin, die sie gemeldet hat?',
		[
			'Alles, was in dem Fall steht',
			'Nichts — sie sieht nur den Status',
			'Nur den ersten Kommentar',
			'Nur das, was ihr ausdrücklich als Antwort oder Rückfrage abgeschickt habt'
		],
		3,
		'Wenn ihr etwas schreibt, ist „intern vermerken" voreingestellt.',
		'Sichtbar ist immer nur der einzelne Beitrag, den ihr hinausschickt. Alles andere bleibt intern — wem ihr den Fall zuweist, wie dringend ihr ihn einstuft und zu welchem Projekt er gehört, sieht sie nie.'
	),

	{
		id: 'melden-beispiel',
		kind: 'compare',
		title: 'Dasselbe Problem, zweimal gemeldet',
		kicker: 'Woran eine Meldung hängt',
		audience: ['INTERN', 'TEACHER', 'STUDENT', 'SUPPORTER'],
		priority: { relevance: 3, urgency: 2, importance: 3 },
		goal: 'Beide Meldungen beschreiben denselben Fehler, beide sind kurz. Bei der linken müssen wir viermal nachfragen. Die rechte können wir sofort nachstellen — und was sich nachstellen lässt, ist meistens am selben Tag behoben.',
		links: {
			label: 'So kommt sie zurück',
			betreff: 'Fehler',
			text: 'Bei einer Schülerin funktioniert das Hochladen nicht. Bitte um Prüfung.',
			folgenTitel: 'Was wir zurückfragen müssen',
			folgen: [
				'Welche Schüler:in, welche Junior Company?',
				'Welche Unterlage, welches Dateiformat?',
				'Was stand auf dem Bildschirm?',
				'Nur sie oder die ganze Klasse?'
			]
		},
		rechts: {
			label: 'So wird sie gelöst',
			betreff: 'Einverständniserklärung lässt sich nicht hochladen (JC Pausenhof)',
			text: 'Lena Berger, JC Pausenhof, Steiermark. Profil → Nachweise → Einverständniserklärung, PDF mit 2,4 MB. Nach „Hochladen" erscheint „Das hat nicht geklappt", das Feld bleibt leer. Seit heute bei drei Schüler:innen derselben Klasse, Bildschirmfoto hängt an.',
			folgenTitel: 'Damit ist ohne Rückfrage klar',
			folgen: [
				'**wer** betroffen ist',
				'**wo** genau es passiert',
				'**was** statt des Erwarteten geschieht',
				'**wie viele** es betrifft'
			]
		},
		watch: 'Die rechte Meldung ist vier Zeilen lang, nicht vierzig. Es geht nicht um Ausführlichkeit, sondern darum, dass jemand anderes den Fall nachstellen kann, ohne nachzufragen. Übrigens: Seite, Rolle und Browser müsst ihr nie abtippen — die gehen von selbst mit.'
	},

	{
		id: 'unterstuetzer',
		kind: 'topic',
		title: 'Unterstützer:innen: aus einer Namensliste wird ein eigener Bereich',
		kicker: 'Der größte Ausbau des Jahres',
		image: unterstuetzer,
		audience: ['INTERN', 'TEACHER', 'STUDENT', 'SUPPORTER'],
		priority: { relevance: 3, urgency: 3, importance: 2 },
		goal: 'Unternehmen und Fachleute, die Junior Companies begleiten, haben jetzt ein eigenes Konto. Sie pflegen ihr Profil selbst, Schulen finden sie über die Suche, und die Zusammenarbeit hat einen Anfang und ein Ende.',
		facts: [
			'Eigener Menüpunkt „Unterstützer:innen"; der frühere Bereich „Wirtschaftsexperten" ist abgelöst.',
			'Wer mitmachen will, meldet sich über eine öffentliche Seite selbst an.',
			'Schüler:innen und Lehrkräfte laden ab heuer selbst ein — meist Bekannte oder Familie, ohne Umweg über euch.',
			'Profil mit Bild, Erreichbarkeit und einem Verlauf, in dem jede Zusammenarbeit steht.'
		],
		rules: [
			'Ihr **seht** eine neue Anmeldung aus eurem Bundesland, **freigeben** darf sie nur die Bundesebene. So bleibt der Maßstab österreichweit derselbe.',
			'Wer bei sich „nimmt keine neuen Companies an" gesetzt hat, bekommt gar keine Anfrage.',
			'Ob jemand im Verzeichnis auftaucht, entscheidet die Person selbst in ihrem Profil.',
			'Eine Pause endet von selbst: „nicht verfügbar bis …" schaltet über Nacht zurück auf aktiv.'
		],
		watch: 'Für eine Übergangszeit stehen zwei Verzeichnisse nebeneinander: die früher von euch erfassten Expert:innen und die neuen Unterstützer:innen mit eigenem Konto. Neu erfassen lässt sich der alte Typ nicht mehr — einladen dafür schon.'
	},
	F(
		'q-unterstuetzer',
		'Eine Unterstützerin aus Tirol meldet sich selbst an. Wer gibt sie frei?',
		[
			'Die Landesadministration Tirol',
			'Die Bundesadministration',
			'Niemand — Selbstanmeldungen sind sofort aktiv',
			'Die Lehrkraft, die sie angefragt hat'
		],
		1,
		'Sehen und freigeben sind hier zwei verschiedene Rechte.',
		'Die Landesadministration sieht das wartende Profil, freigeben darf ausschließlich die Bundesebene. So bleibt der Maßstab österreichweit derselbe.'
	),

	{
		id: 'hygiene',
		kind: 'topic',
		title: 'Neu: Bestätigung zur Lebensmittelhygiene',
		kicker: 'Betrifft etwa jede zweite Company',
		image: hygiene,
		audience: ['INTERN', 'TEACHER', 'STUDENT'],
		priority: { relevance: 3, urgency: 3, importance: 2 },
		goal: 'Wer Lebensmittel verkauft oder körpernah arbeitet, muss vor dem Einreichen angeben, wie Hygiene und Allergene abgedeckt sind. Das betrifft rund die Hälfte: 299 der 592 Junior Companies des Vorjahres waren in solchen Branchen.',
		factsTitle: 'Zwei Angaben stehen zur Wahl',
		facts: [
			'**„Im Lehrplan integriert"** — die Inhalte sind Teil des Unterrichts.',
			'**„Bereits absolviert"** — mit den Namen der Beteiligten und dem Datum.',
			'Angegeben wird es **von den Schüler:innen selbst**, im Unternehmensprofil.',
			'Die betreuende Lehrkraft bekommt eine Nachricht darüber und kann widersprechen.'
		],
		rules: [
			'Ob der Punkt überhaupt auftaucht, entscheidet allein die **Branche** der Junior Company.',
			'Ist die Schulung nicht im Lehrplan abgedeckt, muss sie **vor Beginn der Herstellung** absolviert werden.',
			'Widerspricht die Lehrkraft, ist die Angabe hinfällig und der Punkt wieder offen.',
			'Jede Angabe steht mit Name, Datum und Uhrzeit im Verlauf des Unternehmens.'
		],
		watch: 'Die Anwendung prüft hier nichts nach und bescheinigt auch nichts — sie nimmt eine Selbstauskunft entgegen und schreibt nachvollziehbar mit, wer sie wann gegeben hat. Verantwortlich bleiben Schule, Schulerhalter und betreuende Lehrkraft.'
	},

	{
		id: 'lulupload',
		kind: 'topic',
		title: 'In Junior Basic Companies darf die Lehrkraft hochladen',
		kicker: 'Hilfe für die jüngsten Klassen',
		image: lulupload,
		audience: ['INTERN', 'TEACHER', 'STUDENT'],
		priority: { relevance: 2, urgency: 3, importance: 2 },
		goal: 'In Junior Basic Companies sind die Schüler:innen oft noch sehr jung. Liegt die unterschriebene Erklärung längst in der Klasse, bevor alle ein Konto haben, darf die Lehrkraft sie jetzt an ihrer Stelle hochladen.',
		facts: [
			'Reiter „Nachweise" im Profil der Schüler:in, für die betreuende Lehrkraft.',
			'Gilt für die Einverständniserklärung und — wenn eingeschaltet — die Gen-AI-Urkunde.',
			'Die Lehrkraft kann eine Unterlage außerdem beanstanden oder löschen, beides nur mit Begründung.',
			'Eingeschaltet ist das derzeit **nur für Junior Basic Companies**. Sonst laden die Schüler:innen wie gewohnt selbst hoch.'
		],
		rules: [
			'Geprüft wird weiterhin ausschließlich von euch.',
			'Die Unterlage bleibt der Schüler:in zugeordnet; die Lehrkraft steht nur als handelnde Person im Verlauf.',
			'Die Begründung geht an die Schüler:in und steht im Verlauf.'
		],
		watch: 'Löschen ist endgültig. Für den häufigsten Fall — richtige Erklärung, aber die Unterschrift fehlt — ist „Beanstanden" gemacht: Die Datei bleibt dann liegen und ist weiter zu sehen.'
	},

	{
		id: 'firmenprofil',
		kind: 'topic',
		title: 'Das Unternehmensprofil: alles an einem Ort',
		kicker: 'Aufgeräumt und für alle gleich',
		audience: ['INTERN', 'TEACHER', 'STUDENT'],
		priority: { relevance: 3, urgency: 2, importance: 2 },
		goal: 'Die Angaben einer Junior Company stehen ab heuer in acht benannten Abschnitten, erreichbar über ein Menü an der Seite. Verwaltung, Lehrkraft und Schüler:innen sehen dieselbe Aufteilung — wer einen Abschnitt beanstandet, meint in jeder Rolle denselben.',
		facts: [
			'Basisdaten, Geschäftstätigkeit, Kontakt, Personen, Anteile, Expert:innen, Unterlagen, Markt- und Risikoanalyse.',
			'Über dem Menü steht der Zustand: aktiviert · eingereicht · abgelehnt · noch nicht aktiviert.',
			'Je Abschnitt eine Ampel — auf einen Blick sichtbar, wo noch etwas fehlt.',
			'Dazu Logo, Website und Social-Media-Profile der Junior Company.'
		],
		rules: [
			'Der Fortschrittsbalken zeigt in allen Rollen denselben Stand: Er hängt an derselben Liste wie vorhin.',
			'Die Lehrkraft sieht jetzt dieselben acht Abschnitte wie ihr — bisher sah sie weniger als ihre eigenen Schüler:innen.',
			'Die Markt- und Risikoanalyse ist kein eigener Menüpunkt mehr, sondern ein Abschnitt hier. Alte Lesezeichen leiten von selbst dorthin.'
		]
	},

	{
		id: 'skills4retail',
		kind: 'topic',
		title: 'Skills4Retail: Lernstrecke und Konzept',
		kicker: 'Neues Angebot für den Handel',
		image: skills4retail,
		audience: ['INTERN', 'TEACHER', 'STUDENT'],
		priority: { relevance: 3, urgency: 2, importance: 2 },
		goal: 'Neu im Programm: Junior Companies im Handel arbeiten eine Lernstrecke zum Online-Handel durch und wenden das Gelernte in einem Konzept auf die eigene Firma an. Bewertet wird es von der Lehrkraft.',
		facts: [
			'Zehn Kapitel mit je fünf Fragen; bestanden ab vier richtigen Antworten.',
			'Fünfzehn Felder im Konzept: Die Schüler:innen füllen aus, die Lehrkraft bewertet.',
			'Eigener Menüpunkt „Skills4Retail"; ein Klick auf die Zeile öffnet Konzept und Bewertung.',
			'Alle zehn Kapitel geschafft: Teilnahmebestätigung als PDF.'
		],
		rules: [
			'Die Teilnahmebestätigung gibt es **erst bei vollständigem Abschluss** — bei acht von zehn Kapiteln also noch nicht.',
			'Ob die Lernstrecke Pflicht ist und ab wann sie zurückhält, steht je Unternehmensform in den Einstellungen.',
			'Eine zurückgegebene Bewertung ist wieder offen; „Bewertung abschließen" bestätigt sie.'
		],
		watch: 'Die Teilnahmebestätigung ist nicht die Urkunde am Ende des Junior-Jahres. Die kommt weiterhin von Junior Achievement und ist unterschrieben — diese hier bescheinigt einen Kurs.'
	},

	{
		id: 'news',
		kind: 'topic',
		title: 'Veranstaltungen & Neuigkeiten: wer sieht was, und wann',
		kicker: 'Neue Ansicht, feinere Zielgruppen',
		audience: ['INTERN', 'TEACHER', 'STUDENT'],
		priority: { relevance: 3, urgency: 2, importance: 2 },
		goal: 'Was ihr hier einstellt, erscheint auf der Startseite der Schulen. Zwei Dinge sind neu: eine Ansicht, die zeigt, was wann läuft — und die Möglichkeit, genau festzulegen, wer eine Nachricht überhaupt zu sehen bekommt.',
		facts: [
			'Reiter „Chronologisch": ein Balken je Nachricht, heute als Linie in der Mitte.',
			'An jeder Nachricht steht die Zielgruppe: Bundesland, Rolle, Schultyp, Unternehmensform, Branche.',
			'Jede Nachricht hat zwei Zeitangaben: den Termin der Veranstaltung und die Dauer der Anzeige.',
			'Eine Nachricht lässt sich duplizieren — praktisch für alles, was jedes Jahr wiederkommt.'
		],
		rules: [
			'**Es geht dabei keine E-Mail hinaus.** Wer wirklich alle erreichen will, veröffentlicht einen Unterstützungsbedarf.',
			'Ist bei der Zielgruppe alles angehakt, ist nichts eingeschränkt — dann sehen es alle.',
			'Ein Entwurf ist für niemanden sichtbar, bis ihr ihn aktiviert.'
		],
		watch: 'Der Balken zeigt, wie lange eine Nachricht **angezeigt** wird, und nicht, wann die Veranstaltung ist. Eine Oktober-Veranstaltung, die ab Mai angekündigt wird, hat deshalb einen sehr langen Balken.'
	},
	F(
		'q-news',
		'Ihr legt eine Veranstaltung für den 3. Oktober an. Wann bekommen die Schulen eine E-Mail?',
		[
			'Sofort beim Speichern',
			'Am Tag vor der Veranstaltung',
			'Gar nicht — Veranstaltungen und Neuigkeiten lösen keine E-Mail aus',
			'Sobald die Anzeigedauer beginnt'
		],
		2,
		'Für einen Aufruf, der wirklich E-Mails auslöst, gibt es einen anderen Weg.',
		'Veranstaltungen und Neuigkeiten sind bewusst kein Newsletter: Sie erscheinen auf der Startseite der Schulen, verschicken aber nichts. E-Mails löst nur das Veröffentlichen eines Unterstützungsbedarfs aus.'
	),

	{
		id: 'rest',
		kind: 'topic',
		title: 'Kurz erwähnt, aber gut zu wissen',
		kicker: 'Vier Kleinigkeiten',
		image: anforderungen,
		audience: ['INTERN'],
		priority: { relevance: 2, urgency: 2, importance: 2 },
		goal: 'Vier Neuerungen, die seltener vorkommen — aber gut zu kennen sind, wenn der Fall eintritt.',
		facts: [
			'**Rechnungen** werden storniert statt gelöscht. War eine bezahlte Rechnung falsch, bleibt der Betrag als Guthaben stehen.',
			'**Einladungen** an Mitarbeitende gelten 60 Tage und lassen sich erneut senden oder zurückziehen.',
			'**Der Jahresreset** wird vorher angekündigt; ein nächtlicher Lauf erinnert Schüler:innen und Lehrkräfte daran. Ausgelöst wird dadurch nichts.',
			'**Kommunikation** heißt der Menüpunkt, in dem jede E-Mail und jede Systemnachricht steht, die die Anwendung von sich aus verschickt — mit Text und Anlass.'
		],
		rules: [
			'Ein Guthaben wandert auf die nächste Rechnung desselben Berichts und lässt den Saldo nie unter null fallen.',
			'Eine stornierte Rechnung verschwindet nicht aus der Statistik, sondern bekommt dort eine eigene Kachel.',
			'**Vorsicht bei den Vorlagen:** Wer im Bereich „Kommunikation" einen Text ändert, ändert ihn für ganz Österreich — die Vorlagen sind für alle Bundesländer dieselben.'
		]
	},
	F(
		'q-rechnung',
		'Eine bezahlte Rechnung war falsch. Ihr storniert sie. Was passiert mit dem Geld?',
		[
			'Es wird zurücküberwiesen und die Rechnung verschwindet',
			'Es bleibt als Guthaben stehen und wandert auf die neue Rechnung desselben Berichts',
			'Es verfällt am Schuljahresende',
			'Nichts — der Betrag bleibt der alten Rechnung zugeordnet'
		],
		1,
		'Gelöscht wird nichts mehr; die stornierte Rechnung bleibt sichtbar.',
		'Das Guthaben wandert auf die neue Rechnung desselben Berichts. Der Saldo fällt dabei nie unter null.'
	),

	/*
	 * Die Folie, die aus der Schulung eine Einladung macht.
	 *
	 * Bis 31.08.2026 stand hier eine Folie „Das System ist einstellbar
	 * geworden" mit vier Zeilen über Einstellungen, die eine Landes-
	 * administration gar nicht öffnen kann. Sie beantwortete die Frage nicht,
	 * die eine Schulung am Ende offenlässt: Was soll ich jetzt tun?
	 */
	{
		id: 'mitreden',
		kind: 'topic',
		title: 'Wie ihr helfen könnt',
		kicker: 'Drei Dinge',
		image: einstellungen,
		audience: ['INTERN'],
		priority: { relevance: 3, urgency: 2, importance: 2 },
		goal: 'Vieles, was früher fest eingebaut war, ist heute eine Einstellung: Voraussetzungen, Fristen, Erinnerungen. Damit lässt sich im Lauf des Jahres nachjustieren, was in der Praxis nicht passt. Dafür brauchen wir aber, was ihr seht.',
		factsTitle: 'Damit helft ihr am meisten',
		facts: [
			'**Prüfen, was wartet.** Eine ungeprüfte Elternbestätigung ist oft das Einzige, was eine ganze Klasse noch aufhält.',
			'**Melden statt aushalten.** Alles, was hakt, gehört in „Anforderungen & Anfragen" — auch Kleinigkeiten, auch Wünsche.',
			'**Sagen, was nicht passt.** Fristen, Abstände der Erinnerungen, Pflichtpunkte: Das sind heute Einstellungen und lässt sich ändern.'
		],
		rulesTitle: 'Wo die Einstellungen liegen',
		rules: [
			'Der Menüpunkt „Einstellungen" steht der Bundesadministration offen. Aus einem Bundesland läuft der Wunsch über „Anforderungen & Anfragen" — mit Nummer und Verlauf, damit nichts verloren geht.',
			'Jede Einstellung hat eine Erklärung und ein Beispiel zum Aufklappen.',
			'Wo eine Änderung etwas verschärft, sagt die Anwendung vorher, wen es betrifft.'
		],
		watch: 'Ein leeres Zahlenfeld bedeutet „keine Angabe" und nicht „null". Wo eine Frist gelten soll, gehört also eine Zahl hinein — sonst läuft die Erinnerung dazu gar nicht.'
	},

	{
		id: 'handbuch',
		kind: 'topic',
		title: 'Wo ihr nachschlagt',
		kicker: 'Zwei Nachschlagewerke',
		image: handbuchBild,
		audience: ['INTERN'],
		priority: { relevance: 2, urgency: 1, importance: 2 },
		goal: 'Dieses Onboarding gibt den Überblick. Für den Einzelfall gibt es zwei Nachschlagewerke in der Anwendung — sie beschreiben immer genau den Stand, der gerade läuft.',
		facts: [
			'**Handbuch** — zehn Kapitel mit Volltextsuche: Begriff eintippen, die Fundstellen werden hervorgehoben und der Reihe nach angesprungen.',
			'**Änderungsliste** — jede Änderung, die ausgeliefert wurde, mit Datum und Bereich.'
		],
		rules: [
			'Was in der Änderungsliste steht, ist ausgeliefert — nicht geplant.',
			'Wo sich im Handbuch etwas nicht belegen ließ, steht das ausdrücklich dabei statt einer Vermutung.',
			'Was ihr meldet, steht mit Nummer und Stand in „Anforderungen & Anfragen".'
		]
	},

	{
		id: 'profilbild',
		kind: 'task',
		title: 'Zum Schluss: euer Profilbild',
		kicker: 'Einmal machen, überall sichtbar',
		audience: ['INTERN', 'TEACHER', 'STUDENT', 'SUPPORTER'],
		priority: { relevance: 2, urgency: 2, importance: 1 },
		goal: 'Ab heuer hat jede Rolle ein Profilbild. In Verläufen und Zuweisungen steht damit ein Gesicht statt eines Kürzels — bei einem Team über neun Bundesländer macht das aus einer Kennung eine Kollegin.',
		facts: [
			'Ein Klick auf den Kreis unten: auswählen, zuschneiden oder drehen, fertig.',
			'Es erscheint überall dort, wo bisher die Initialen standen — und auf eurer Abschlusskarte.',
			'Ändern oder wieder entfernen geht jederzeit im eigenen Profil.'
		],
		rules: [
			'Kein Bild ist kein Fehler: Dann stehen weiterhin die Initialen.',
			'Das Bild kommt aus eurem Konto, der Name aus dem jeweiligen Eintrag.'
		],
		task: {
			key: 'profilbild',
			label: 'Profilbild hinterlegt'
		}
	},

	/*
	 * Die Abschlussfolie hat zwei Fassungen. Davor schließt sie ab, danach
	 * gratuliert sie — ein Schlussbild, das nach dem Bestehen dasselbe sagt wie
	 * davor, fühlt sich an wie nichts passiert.
	 *
	 * Und sie **duzt**, als einzige Folie. Der Rest der Schulung spricht die
	 * Runde an („eure Arbeit"), hier steht eine einzelne Person mit ihrer
	 * eigenen Karte und ihrem eigenen Gesicht darauf.
	 */
	{
		id: 'ende',
		kind: 'outro',
		title: 'Auf in ein neues Junior-Jahr',
		titleDone: 'Geschafft — auf ein erfolgreiches Junior-Jahr 2026/27!',
		image: fuehrerschein,
		lead: 'Ein Schritt fehlt noch: abschließen. Dein Ergebnis steht danach in deinem Profil, und wer mag, geht das Onboarding später noch einmal durch — das Abschlussdatum bleibt erhalten.',
		leadDone:
			'Gratulation — du hast den Überblick. Damit beginnt das Schuljahr 2026/27 mit sechshundert Junior Companies, die auf euch zählen. Alles Weitere steht im Handbuch, und dort gibt es eine Volltextsuche: Ein Begriff genügt, die Fundstellen werden hervorgehoben und der Reihe nach angesprungen.'
	}
]

/** Nur die Folien (ohne Fragen) — für Fortschritt und Inhaltsverzeichnis. */
export const SLIDE_ITEMS = SLIDES.filter(item => item.kind)

/** Nur die Fragen — für die Auswertung. */
export const QUESTIONS = SLIDES.filter(item => !item.kind)

export const TOTAL_QUESTIONS = QUESTIONS.length

/** Wie viele Joker es insgesamt gibt. Drei — genug für einen schlechten Tag. */
export const JOKER_BUDGET = 3
